import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { useInputChange } from 'hooks/useInputChange';
import { ViewDataUsers } from 'components/containers/dashboard/dataUsers/ViewComponent';
import { IdUsersState, typeUsersFilters } from 'model/dashboardUsers/dUsersReducer';
import {
    dUsersClearFiltersAC, dUsersDeleteItemSagaAC, dUsersRecoverBulkSagaAC,
    dUsersSetDataSagaAC, dUsersSetDetailItemAC,
    dUsersSetFiltersAC, dUsersSetItemsForPageAC, dUsersSetPageNumberAC
} from 'model/dashboardUsers/dUsersActionCreators';
import { ISystemState } from 'model/system/systemReducer';
import {
    typePaginationDashboardObject
} from 'components/containers/dashboard/DashboardContentTable/PaginationDashboard/PaginationDashboard';


// Type
export type typeUsers = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeDataUsersRowActions = { title: JSX.Element, action: (id: string) => void }[]


// Component
export const DataUsers: React.FC<typeUsers> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    // System data
    const position = useSelector((state: { system: ISystemState }) => state.system.userInfo?.position)

    // DateFilter
    const [ isActiveFilters, setIsActiveFilters ] = useState(false)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)
    const filters = useSelector((state: { dUsers: IdUsersState }) => state.dUsers.filters)

    // Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dUsers: IdUsersState }) => state.dUsers.pagination),
        onGoToPage: (id) => dispatch(dUsersSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dUsersSetItemsForPageAC(itemsPerPage))

    }


    // Did mount & Did unmount
    useEffect(() => {

        return () => {
            dispatch(dUsersClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(dUsersSetDataSagaAC(filters,
                                     {
                                         page: pagination.paginationObject.pageNumber,
                                         size: pagination.paginationObject.itemsPerPage!
                                     }))
        // eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber, pagination.paginationObject.itemsPerPage ])

    // Search panel

    const searchUserName = useSelector((state: { dUsers: IdUsersState }) => state.dUsers.filters?.name)

    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchUserName || '')

    const onClearSearch = () => {
        dispatch(dUsersSetFiltersAC({
                                        name: null
                                    }))
        setSearchValue('')
    }
    const onEnterSearch = () => {

        const filters: typeUsersFilters = {
            name: searchValue.trim()
        }
        dispatch(dUsersSetFiltersAC(filters))

    }

    // Current item
    const currentItem = useSelector((state: { dUsers: IdUsersState }) => state.dUsers.detailItem)

    // Popup add
    const [ openPopupAdd, setOpenPopupAdd ] = useState(false)

    // Popup edit
    const [ openPopupEdit, setOpenPopupEdit ] = useState(false)

    // Delete dialog
    const [ openDeleteDialog, setOpenDeleteDialog ] = useState(false)

    // Delete dialog actions
    const onDeleteCancelHandler = () => {
        setOpenDeleteDialog(false)
    }
    const onDeleteConfirmHandler = () => {
        dispatch(dUsersDeleteItemSagaAC(currentItem!.id, filters, {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!
        }))
        setOpenDeleteDialog(false)
    }

    // Recover dialog
    const [ openRecoverDialog, setOpenRecoverDialog ] = useState(false)
    const onRecoverConfirmHandler = () => {
        dispatch(dUsersRecoverBulkSagaAC([ currentItem!.id ], filters, {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!
        }))
        setOpenRecoverDialog(false)
    }
    const onRecoverCancelHandler = () => {
        setOpenRecoverDialog(false)
    }


    // Make table item actions
    const rowsActions = [
        {
            title: <Trans>Edit</Trans>,
            action: (id: string) => {
                dispatch(dUsersSetDetailItemAC(id))
                setOpenPopupEdit(true)
            }
        },
        {
            id: 'recover',
            title: <Trans>Recover</Trans>,
            action: (id: string) => {
                dispatch(dUsersSetDetailItemAC(id))
                setOpenRecoverDialog(true)
            }
        },
        {
            id: 'delete',
            title: <Trans>Delete</Trans>,
            action: (id: string) => {
                dispatch(dUsersSetDetailItemAC(id))
                setOpenDeleteDialog(true)
            }
        },
    ]

    return (
        <ViewDataUsers

            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupAdd={ openPopupAdd }
            setOpenPopupAdd={ setOpenPopupAdd }

            openPopupEdit={ openPopupEdit }
            setOpenPopupEdit={ setOpenPopupEdit }

            openDeleteDialog={ openDeleteDialog }
            setOpenDeleteDialog={ setOpenDeleteDialog }
            onDeleteConfirmHandler={ onDeleteConfirmHandler }
            onDeleteCancelHandler={ onDeleteCancelHandler }

            openRecoverDialog={ openRecoverDialog }
            setOpenRecoverDialog={ setOpenRecoverDialog }
            onRecoverConfirmHandler={ onRecoverConfirmHandler }
            onRecoverCancelHandler={ onRecoverCancelHandler }

            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onEnterSearch={ onEnterSearch }
            onClearSearch={ onClearSearch }

            rowsActions={ rowsActions }

            currentItem={ currentItem }
            pagination={ pagination }
            isActiveFilters={ isActiveFilters }
            setIsActiveFilters={ setIsActiveFilters }
            position={ position }
        />

    )
}
